import React, { useState } from "react";
import Settings from "./Settings";
import FeedbackBox from "./FeedbackBox";
import SignInModal from "./signinModal";
import IntroFormModal from "./introFormModal";
//import { useAuth0 } from "@auth0/auth0-react";
import { LogoutButton } from "./signin";
import EndScreenModal from "./endScreenModal";
import SubscribeToProduct from "./subscribeToProduct";
import { AppWrapper } from "./styles";
import { useNavigate } from "react-router-dom";
import { User } from "@/utils/types";
import { useAppContext } from "../appContext";
import ErrorModal from "./errorModal";
import NextConfirmation from "./NextConfirmation";
import { updateIntakeForm, updateAudio, uploadUserResume } from "../api";
import { hasPremSub, isAdmin } from "../utils/utils";
import Button from "@mui/material/Button";
import { Menu, MenuItem } from "@mui/material";
import { ArrowDropDown } from "@mui/icons-material";

function Nav() {
  const {
    auth0,
    state,
    reducers,
    navigateThenRun,
    goToStartCont,
    showError,
    getFeedback,
    showFeedbackPopUp,
    stopAudio,
    refreshUser,
  } = useAppContext();
  const {
    setstart,
    setqPrompt,
    setloading,
    setinterviewer,
    updatesession,
    setquestions,
    setcurrentQuestion,
    setcurrScreen,
    setgetq,
    setrole,
    setdomain,
    setcustomQ,
    setjobDescriptionQ,
    settype,

    setprocessing,
    setshowAns,
    setshowFeedback,
    setshowAction,
    setcanStop,
    setcodingLang,
    setnext,
    setprevious,
    setshowNextConfirmation,
    setshowHistoryModal,
    setshowsigninModal,
    setshowintroFormModal,
    setshowPaymentModal,
    setshowTranscript,
    setshowApiError,
    setsession,
    setErrorText,
    setshowSettings,
    setshowFeedbackBox,
    setprofileUser,
    setintQuestion,
    setqType,
    setquestionQuery,
    setspeechLen,
    sethitMaxLen,
    setdisplayPastFeedback,
    setpastInfo,
    setretryPast,
    setbeginningLoad,
    setNextFunc,
    setfeedbackNextFunc,
    setAbortController,
    setGPTCallCount,
    setcontextLength,
  } = reducers;

  const NextConfirmationModal = (): void => {
    setshowNextConfirmation(!state.showNextConfirmation);
  };

  const showNext =
  state.session[state.currentQuestion]?.prompt.length > 0 && state.session[state.currentQuestion]?.feedback == "" ?  () => setshowNextConfirmation(true) : null;

  const goToStart = async (startPath: boolean = false): Promise<void> => {
    if (state.start) {
      stopAudio();
    }
    if (!startPath) {
        window.location.href = "https://www.thedevdifference.com";
    } else if(showFeedbackPopUp()){
        setfeedbackNextFunc(() => {
          navigateThenRun(() => {
            goToStartCont();
          }, "/");
        });
    }
    else{//clicked not from interviewscren
      navigateThenRun(() => {
        goToStartCont();
      }, "/");
    }
  };

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleMenuClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const canClosePopup =
    location.pathname !== "/interview" ||
    (state.profileUser !== null &&
      state.canPractice &&
      hasPremSub(state.profileUser));

  // TODO: Use this function in the intake form to submit the form
  const submitForm = async (form: any): Promise<void> => {
    let user2 = await updateIntakeForm(form);
    setprofileUser(user2);
  };

  const settingModal = (): void => {
    setshowSettings(!state.showSettings);
  };

  const signinModal = (): void => {
    setshowsigninModal(!state.showsigninModal);
  };

  const GoToProgress = (): void=>{
    if (showNext !== null) {
      setNextFunc(() => {
          setfeedbackNextFunc(() => {
            navigateThenRun(()=>{setsession([])}, "/history")
          });
      });
      showNext();
    }
    else if(showFeedbackPopUp()){
      setfeedbackNextFunc(() => {
      navigateThenRun(()=>setsession([]), "/history");
      });
    }

    else{//clicked not from interviewscren
      navigateThenRun(()=>setsession([]), "/history");
    }
  }

  const feedbackBoxModal = (): void => {
    setshowFeedbackBox(!state.showFeedbackBox);
  };

  const UpdateAudio = async (e: boolean): Promise<void> => {
    if (state.profileUser && state.profileUser.audioEnabled !== e) {
      const user2 = await updateAudio(e);
      if (user2 && user2.audioEnabled === false) {
        stopAudio();
      }
      setprofileUser(user2);
    }
  };

  const UpdateResume = async (text: string, file: string): Promise<void> => {
    if (text !== state.resume.resumeText) {
      const user2 = await uploadUserResume(text, file);
      setprofileUser(user2);
    }
  };

  return (
    <>
      <ErrorModal
        showApiError={state.showApiError}
        toggleApiError={(val) => showError(val)}
        errorText={state.errorText}
      />
      <NextConfirmation
        showNextConfirmation={state.showNextConfirmation}
        toggleNextConfirmation={() => NextConfirmationModal()}
        Next={() => {
          setshowNextConfirmation(false);
          if (state.nextFunc !== null) {
            state.nextFunc();
          }
        }}
        GetFeedback={() => {
          setshowNextConfirmation(false);
          getFeedback();
        }}
      />
      <nav className="banner-nav">
        <div className="titleicon">
          <a
            data-custom-id="TitleClick"
            onClick={() => {
              if (showNext !== null) {
                setNextFunc(() => {
                  goToStart(false);
                });
                showNext();
              } else {
                goToStart(false);
              }
            }}
          >
            The <span className="orange">&#123;</span>Dev
            <span className="orange">&#125;</span> Difference
          </a>
        </div>
        <div className="responsive-container">
        {state.canPractice &&  <div data-custom-id="admin" className="menuoption">
              <Button
                color="inherit"
                onClick={() => {
                  if (showNext !== null) {
                    setNextFunc(() => {
                      navigateThenRun(() => {
                        goToStart(true);
                      }, "/");
                    });
                    showNext();
                  } else {
                    navigateThenRun(() => {
                      goToStart(true);
                    }, "/");
                  }
                }}
                sx={{ textTransform: "none" }}
              >
                Dashboard
              </Button>
            </div>}
          
          {state.canPractice && (
            <div  className="menuoption">
            <Button
              color="inherit"
              onClick={() =>
                hasPremSub(state.profileUser)
                  ? GoToProgress()
                  : setshowPaymentModal(true)
              }
              sx={{ textTransform: "none" }}
            >
              Progress
            </Button>
          </div>
          )}
          {state.canPractice && isAdmin(state.profileUser) && (
            <div data-custom-id="admin" className="menuoption">
              <Button
                color="inherit"
                onClick={() => navigateThenRun(null, "/admin")}
                sx={{ textTransform: "none" }}
              >
                Admin
              </Button>
            </div>
          )}
          <div className="menuoption">
          <Button
          color="inherit"
          onClick={handleMenuClick}
          sx={{textTransform: "none"}}
          endIcon={<ArrowDropDown />}
        >
          Help
        </Button>
        <Menu
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          MenuListProps={{
            "aria-labelledby": "basic-button",
          }}
        >
          <MenuItem onClick={()=>{handleClose();window.open("https://docs.google.com/forms/d/e/1FAIpQLSf_CISqn0rFNWO24lrVPjriP6BZ_y3Aw1aTLKVvpEgI4_LtlQ/viewform?usp=sf_link", "_blank")}}>Share Feedback</MenuItem>
          <MenuItem onClick={() => { handleClose(); window.location.href = 'mailto:info@thedevdifference.com';}}>Contact Us</MenuItem>
         
        </Menu>
        </div>
        {!state.canPractice && state.profileUser !== null && 
          <div className="menuoption">
             <Button
             color="inherit">
            <LogoutButton />
            </Button>
            </div>}
          {state.canPractice && (
            <div className="menuoption">
              <a className='responsive-container' data-custom-id="profile">
                <i onClick={() => {
                 navigateThenRun(null, '/profile')
                }} className="far fa-circle-user menuIcon"></i>
              </a>
            </div>
          )}
          {state.canPractice && (
            <div className="menuoption">
              <a className='responsive-container' data-custom-id="enableaudio">
                <i title={!state.profileUser?.audioEnabled ? "enable interviewer audio": "disable interviewer audio"} onClick={()=>UpdateAudio(!state.profileUser?.audioEnabled)}  className={state.profileUser?.audioEnabled ? "fas fa-volume-high menuIcon":"fas fa-volume-xmark menuIcon" }></i>
              </a>
            </div>
          )}
          {!(state.profileUser !== null || auth0.isLoading) && (
            <div
              className="menuoptionLogin"
              onClick={() => auth0.loginWithPopup()}
            >
              Sign in
            </div>
          )}
          {state.profileUser !== null && !hasPremSub(state.profileUser) && (
            <div
              className="menuoptionLogin"
              onClick={() => setshowPaymentModal(true)}
            >
              Premium
            </div>
          )}
        </div>
        {state.memberFeedbackModal !== null && state.memberFeedbackModal}
        {state.questionModal !== null && state.questionModal}
        {state.overlayComp !== null && state.overlayComp}
        <SignInModal
          showSignIn={state.showsigninModal}
          canClosePopup={canClosePopup}
          togglesigninModal={() => signinModal()}
        />
        {/* {state.showPaymentModal && (
          <SubscribeToProduct
            showPaymentModal={state.showPaymentModal}
            togglePaymentModal={(val) => setshowPaymentModal(val)}
            setProfileUser={setprofileUser}
            canClosePopup={canClosePopup}
          />
        )} */}
        <Settings
          showSettings={state.showSettings}
          toggleSettings={() => settingModal()}
          updateResume={(t, f) => UpdateResume(t, f)}
          setAudio={(e) => UpdateAudio(e)}
          audioEnabled={state.userAudio}
          user={state.profileUser}
        />
        <FeedbackBox
          updateIsHelpful={(e) => updatesession({ isHelpful: e })}
          updateIsHelpfulMessage={(e) => {
            updatesession({ isHelpfulMessage: e });
          }}
          showFeedbackBox={state.showFeedbackBox}
          toggleFeedbackBox={() => feedbackBoxModal()}
          isHelpful={
            state.session.length > 0 && state.currentQuestion >= 0
              ? state.session[state.currentQuestion].isHelpful
              : null
          }
          isHelpfulMessage={
            state.session.length > 0 && state.currentQuestion >= 0
              ? state.session[state.currentQuestion].isHelpfulMessage
              : null
          }
        />
      </nav>
      <div className="pseudo-nav" />
    </>
  );
}

export default Nav;
